<template>
  <span class="span-form-txt txt-type1"
        v-if="title">{{ title }}</span>
  <select :style="{width}"
          v-model="selCd"
          @change="selCd_change"
          :disabled="props.disabled">
    <option v-if="isAll"
            value="">전체</option>
    <option v-if="isSelect"
            value="">선택</option>
    <option v-for="info in cds"
            :key="'cd_' + info[cdTxt]"
            :value="info[cdTxt]">{{ info[nmTxt] }}</option>
  </select>
</template>

<script setup>
import {defineProps, defineEmits, computed, ref, toRefs, watch} from "vue";

const props = defineProps({
  title: String,
  isAll: Boolean, //전체
  isSelect: Boolean,  //선택
  cdTxt: {
    type: String,
    default: 'cd',
  },
  nmTxt: {
    type: String,
    default: 'nm',
  },
  cds: {
    type: Array,
    required: true
  },
  cd: String,
  width: {
    type: String,
    default: '120px'
  },
  disabled: {
    type: Boolean,
    default: false
  },
});

const emits = defineEmits(['select']);

let cds = computed(() => JSON.parse(JSON.stringify(props.cds)));

const { cd } = toRefs(props);
const selCd = ref(cd.value);
watch(cd, (newCd) => {
  selCd.value = newCd;
});

const selCd_change = () => {
  emits('select', selCd.value);
}
</script>

<style scoped>

</style>